import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ReflectionsFacade } from '../facades/reflections.facade';

export function reflectionsCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const reflectionsFacade = inject(ReflectionsFacade);
        reflectionsFacade.clear();

        return true;
    };
}
